export default __webpack_public_path__ + "static/media/escape.b4328ae1.mp3";